import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@api/auth/auth.service';
import { AD_RETURN_V2_HOME, consumeAdReturnToV2 } from '@core/constants/ad-return.const';
import { RoutePath } from '@core/enums/route-path.enum';
import { NotificationService } from '@services/notification.service';
import { Logger } from '@utils/logger.util';

@Component({
  selector: 'app-ad-redirect',
  templateUrl: './ad-redirect.component.html',
  styleUrls: ['./ad-redirect.component.scss']
})
export class AdRedirectComponent {
  constructor(
    private route: ActivatedRoute, 
    private router: Router, 
    private authService: AuthService,
    private notificationService: NotificationService
  ) { }

  loading = true;
  error = false;
  success = false;
  errorMessage = '';

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      if (Object.keys(params).length > 0) {
        try {
          const response = await this.authService.adGetToken(params);
          this.success = true;
          this.loading = false;

          // Mostrar estado de éxito brevemente antes de redirigir
          setTimeout(() => {
            if (consumeAdReturnToV2()) {
              window.location.href = AD_RETURN_V2_HOME;
              return;
            }
            this.goToPath(`${RoutePath.BACKOFFICE}/${RoutePath.HOME}`);
          }, 1500);

        } catch (error) {
          Logger.error('Error en autenticación AD:', error);
          this.error = true;
          this.loading = false;
          this.errorMessage = 'No se pudo autenticar con Active Directory. Verifica tus credenciales.';
          this.notificationService.showError(this.errorMessage);
        }
      } else {
        // No hay parámetros, mostrar error
        this.error = true;
        this.loading = false;
        this.errorMessage = 'No se recibieron parámetros de autenticación.';
        this.notificationService.showWarning(this.errorMessage);
      }
    });
  }

  retryAuthentication(): void {
    // Recargar la página para reintentar
    this.goToAdLink();
  }

  private goToPath(path: string) {
    this.router.navigate([path]);
  }

  private async goToAdLink() {
    try {
        const authResponse = await this.authService.adGetLink();
        const url = authResponse.response?.data;
        
        if (!url) {
            Logger.error('No se recibió URL de autenticación AD');
            this.notificationService.showError('No se pudo obtener el enlace de autenticación.');
            this.error = true;
            this.loading = false;
            return;
        }

        window.location.href = url;
    } catch (error) {
      Logger.error('Error al obtener enlace AD:', error);
      this.error = true;
      this.loading = false;
      this.errorMessage = 'No se pudo autenticar con Active Directory. Verifica tus credenciales.';
      this.notificationService.showError(this.errorMessage);
    }
}
}
